import { addDoc, setDoc, updateDoc } from "firebase/firestore";

function isPlainObject(value) {
  if (Object.prototype.toString.call(value) !== "[object Object]") return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

export function sanitizeForFirestore(value) {
  if (value === undefined) return null;
  if (value === null) return null;
  if (Array.isArray(value)) {
    return Array.from({ length: value.length }, (_, index) => sanitizeForFirestore(value[index]));
  }
  if (isPlainObject(value)) {
    return Object.entries(value).reduce((acc, [key, item]) => {
      acc[key] = sanitizeForFirestore(item);
      return acc;
    }, {});
  }
  return value;
}

export function safeSetDoc(ref, data, options) {
  return setDoc(ref, sanitizeForFirestore(data), options);
}

export function safeAddDoc(ref, data) {
  return addDoc(ref, sanitizeForFirestore(data));
}

export function safeUpdateDoc(ref, data) {
  return updateDoc(ref, sanitizeForFirestore(data));
}
